export default __webpack_public_path__ + "static/media/Invitation invalid.bac156b7.png";